import axios from 'axios';
import { API_URL } from './api';

export const storecMobielService = {
    listUsers () {
        console.log('storecMobielService: listUsers');

        return axios
            .get(`${API_URL}/storecmobiel/gebruikers`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    listLocations (id) {
        console.log('storecMobielService: listLocations', id);

        return axios
            .get(`${API_URL}/storecmobiel/vestiginggebruikers/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    create (id, formData) {
        console.log('storecMobielService: create');

        return axios
            .post(`${API_URL}/vestigingen/${id}`, formData)
            .then((response) => response);
    },

    createUser (formData) {
        console.log('storecMobielService: createUser');

        return axios
            .post(`${API_URL}/storecmobiel/gebruikers`, formData)
            .then((response) => response);
    },

    updateUser (id, formData) {
        console.log('storecMobielService: updateUser');

        return axios
            .put(`${API_URL}/storecmobiel/gebruikers/${id}`, formData)
            .then((response) => response);
    },

    updateLocation (id, formData) {
        console.log('storecMobielService: listLocations', id);

        return axios
            .put(`${API_URL}/storecmobiel/vestiginggebruikers/${id}`, formData)
            .then((response) => response);
    },

    deleteUser (id, formData) {
        console.log('storecMobielService: deleteUser');

        return axios
            .delete(`${API_URL}/storecmobiel/gebruikers/${id}`, formData)
            .then((response) => response);
    },

    checkEmail (email) {
        console.log('storecMobielService: checkEmail');

        return axios
            .get(`${API_URL}/storecmobiel/registreer?emailadres=${email}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    get (id) {
        console.log('storecMobielService: get', id);

        return axios
            .get(`${API_URL}/storecmobiel/gebruikers/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },
};

export default storecMobielService;
